import { Box, Chip } from "@mui/material";
import AddQuarter from "../../../views/appraisal/quarterManagement/AddQuarter";
import DeleteQuarter from "../../../views/appraisal/quarterManagement/DeleteQuarter";
import { Icon } from "@iconify/react";

export const Quarter_Table_Head = (data) => [
  {
    field: "sl_no",
    headerName: "Sl No",
  },
  {
    field: "appraisal_tag_name",
    headerName: "Name",
    width: 200,
  },
  {
    field: "appraisal_tag_status",
    headerName: "Status",
    width: 150,
    renderCell: (params) => {
      if (params.row.appraisal_tag_status === 1) {
        return <Chip label="Active" variant="outlined" color="success" />;
      } else {
        return <Chip label="Inactive" variant="outlined" color="warning" />;
      }
    },
  },
  {
    field: "color",
    headerName: "Quarter Color",
    width: 150,
    renderCell: (params) => {
      return (
        <Box
          sx={{
            width: "auto",
            height: "auto",
            py: "6px",
            px: "8px",
            backgroundColor: `${params.row.color}`,
            display: "flex",
            alignItems: "center",
            color: "#fff",
            justifyContent: "center",
          }}
        >
          {params.row.appraisal_tag_name}
        </Box>
      );
    },
  },
  {
    field: "created_on",
    headerName: "Created On",
    width: 200,
  },
  {
    field: "update",
    headerName: "Edit",
    width: 150,
    renderCell: (params) => {
      return (
        <AddQuarter
          appraisalID={params.row.appraisal_tag_id}
          appraisalName={params.row.appraisal_tag_name}
          Tagstatus={params.row.appraisal_tag_status}
          colorTag={params.row.color}
          dispatchParams={data}
        />
      );
    },
  },
  {
    field: "delete",
    headerName: "Delete",
    width: 150,
    renderCell: (params) => {
      return <DeleteQuarter id={params.row.appraisal_tag_id} data={data} />;
    },
  },
];
